// 西班牙
module.exports = {
  common: {
    edit: "editar",
    apply: "Aplicar",
    activate: "activación",
    delete: "borrar",
    cancel: "Cancelar",
    success: "éxito",
    fail: "fallar",
    save: "ahorrar",
    ensure: "Seguro",
    submit: "entregar",
    remark: "Observación",
    detail: "Controlar",
    action: "funcionar",
    open: "abierto",
    close: "cierre",
    back: "devolver",
    export: "exportar",
    modify: "Revisar",
    layout: "desconectar",
    noListData: "La lista no tiene datos",
    more: "Detalles",
    add: "Agregar",
    delSuccess: "¡eliminado con éxito!",
    addFailure: "¡Error al agregar!",
    logOut: "cerrar sesión",
    delAllInfo: "¿Desea continuar con la operación de eliminación?",
    saveTip:
      "No has guardado el contenido de la página, ¿quieres seguir saliendo?",
    tip: "pista",
    yes: "Sí",
    no: "No",
    delTip: "Marcar para activar",
    batchDelete: "eliminación por lotes",
    search: "Preguntar",
    permission: "Sin permiso todavía, por favor regrese",
    reset: "reiniciar",
  },
  breadcrumbItem: {
    home: "Configuración de lista de nombres",
    data: "Empaquetado de configuración general del dispositivo",
    alarm: "Configuración de Zonas",
    house: "Configuración del diseño de la casa",
    name: "Configuración de lista de nombres",
  },
  errorRes: {
    res82: "El sistema está ocupado, inténtalo de nuevo más tarde",
  },
  openConfig: {
    title: "Configuración General del Dispositivo",
    version: "Versión del protocolo",
    versionTip: "Seleccione una versión de protocolo",
    checkVersion:
      "La versión del protocolo no puede estar vacía, elija de nuevo",
    signType: "Tipo de algoritmo de firma",
    checkSignType:
      "El tipo de algoritmo de firma no puede estar vacío, elija de nuevo",
    fileLabel: "Seleccione un documento",
    addFile: "agregar archivos",
    fileName: "Nombre del archivo",
    zipType: "Método de compresión",
    noZip: "sin compresión",
    noFile: "No hay archivos añadidos todavía",
    checkFile: "El archivo de configuración está vacío, agregue un archivo",
    name: "nombre",
    nameTip: "La longitud de entrada es de 1 a 10 dígitos",
    checkName: "El nombre no puede estar vacío, vuelva a ingresar",
    checkName1: "Ingreso de nombre incorrecto, vuelva a ingresar",
    room: "ID del dispositivo",
    roomTip:
      'La longitud de entrada es de 1 a 24 bits y el nivel se distingue por "-"',
    checkRoom:
      "El número de dispositivo no puede estar vacío, vuelva a ingresarlo",
    checkRoom1:
      "La entrada del número de dispositivo es incorrecta, vuelva a ingresar",
    pic: "imagen",
    add: "Añadir",
    reset: "reiniciar",
    picTip: "El tamaño máximo de carga de un archivo de imagen es de 3 m",
    checkPic: "El archivo de imagen no puede estar vacío, vuelva a seleccionar",
    imgRegTip: "Solo sube archivos en formato jpg, jpeg, png",
    excRegTip: "Solo sube archivos en formato xls y xlsx",
    zipRegTip: "Solo sube archivos en formato zip",
    produce: "Generar archivo de configuración",
    confType: "Tipo de configuración",
    pack: "Embalar",
    batchAdd: "Agregar lote",
    singleAdd: "Adición única",
    modelBatch: "Descargar plantilla de importación por lotes",
    uploadInfo: "Subir información básica Excel",
    uploadPic: "Subir paquete de imágenes Zip",
    addName: "Añadir un solo dato",
    sameTip: "Número de serie:",
    sameTip1: "Número de dispositivo duplicado",
    modelError:
      "El contenido del archivo de información básica cargado es incorrecto, modifique el archivo de acuerdo con la plantilla",
    noPic:
      "Hay datos en la lista que no se han agregado con imágenes, debe completar las imágenes antes de generar el archivo de configuración",
    picBtnTip: "Cargue primero el archivo de información básica",
    devType: "Tipo de equipo",
    devTypeTip: "Seleccione un tipo de dispositivo",
    checkDevType: "El tipo de dispositivo no puede estar vacío, elija de nuevo",
    indexName: "número de serie",
    IS: "Unidad interior",
    GU: "Máquina de gestión",
    OS1: "Estación de voz",
    OS2: "Máquina de pared",
    OS3: "Estación de puerta pequeña",
    nameListTip:
      "En los datos básicos cargados, hay datos con un campo de nombre incompleto, y el resto de los datos correctos se han importado",
    numListTip:
      "En los datos básicos cargados, hay datos incompletos en el campo de número de dispositivo, y el resto de los datos correctos se han importado",
  },
  alarm: {
    ad: "Zona AD",
    io: "Zona E/S",
    alarmPlus: "Expansión de Zona",
    num: "número de serie",
    open: "abierto",
    close: "cerca",
    machine: "Tipo de detector",
    sendType: "Tipo de disparador",
    mode: "modelo",
    mType1: "infrarrojo",
    mType2: "Puerta Magnética",
    mType3: "imán de ventana",
    mType4: "gas",
    mType5: "fumar",
    mType6: "timbre de la puerta",
    mType7: "Botón de boletín",
    mType8: "Sensor de puerta infrarrojo",
    mType9: "Sensor de puerta de alarma de mano",
    mType10: "vibración",
    mType11: "presión del aire",
    mType12: "otro",
    send1: "Reportar inmediatamente dentro de las 24 horas",
    send2: "Alarma retardada",
    send3: "Retraso de transferencia",
    send4: "Llamar a la policía inmediatamente",
    send5: "Alarma cruzada",
    mode1: "Normalmente abierto",
    mode2: "A menudo apagado",
    presence: "en casa",
    leaving: "Dejando el hogar",
    timeSet: "Ajuste de tiempo relacionado con el armado",
    delayTime: "Retardo efectivo de armado (segundos)",
    startDelay: "Retardo de disparo de alarma (segundos)",
    startUtil: "Duración de la alarma (minutos)",
    associated: "Zona Asociada",
  },
  house: {
    dev: "equipo",
    scene: "Escenas",
    vine: "sensor",
    single: "Control independiente de escenas",
    light: "luz",
    air: "aire acondicionado",
    heat: "calefacción por suelo",
    fresh: "Viento fresco",
    switch: "Zócalo del interruptor",
    curtain: "cortina",
    water: "calentador de agua",
    bgm: "Música de fondo",
    cust: "Dispositivo personalizado",
    slight: "luz",
    sAir: "aire acondicionado",
    sHeat: "calefacción por suelo",
    sFresh: "Viento fresco",
    sSwitch: "Zócalo del interruptor",
    sCurtain: "cortina",
    sWater: "calentador de agua",
    sBgm: "Música de fondo",
    sCust: "Dispositivo personalizado",
    IndependentControl: "Control independiente de escenas",
    scene1: "escena 1",
    scene2: "Escena 2",
    scene3: "Escena 3",
    scene4: "Escena 4",
    scene5: "Escena 5",
    scene6: "Escena 6",
    scene7: "Escena 7",
    scene8: "Escena 8",
    temp1: "temperatura",
    temp2: "humedad",
    temp3: "metano",
    temp4: "gas orgánico",
    picTip: "No hay plano de planta",
    upload: "Subir plano de planta",
    imgSize:
      "El tamaño de la imagen de un solo plano de planta no debe exceder los 10M",
    imgName:
      "El nombre del archivo del plano de planta cargado no debe aparecer en chino, elija de nuevo",
    imgLength:
      "El número total de cargas y adiciones de planos de planta no debe exceder las 8, y las primeras 8 imágenes en la carpeta se han seleccionado automáticamente",
    imgCheckTip: "El plano de planta no coincide, vuelva a subirlo",
    room1: "Casa Tipo 1",
    room2: "Casa Tipo 2",
    room3: "Casa Tipo 3",
    room4: "Casa Tipo 4",
    room5: "Casa Tipo 5",
    room6: "Casa Tipo 6",
    room7: "Casa Tipo 7",
    room8: "Casa Tipo Figura 8",
    download: "exportar",
    input: "Importar configuración",
    title: "Tabla de parámetros del equipo",
    name: "nombre",
    location: "Ubicación",
    start: "puesta en marcha",
    see: "visible",
    noSee: "Invisible",
    belong: "pertenece a",
    bgIcon: "Icono azul gris",
    vineTip:
      "Seleccione el plano de planta antes de configurar las propiedades de control de temperatura",
    sceneTip:
      "Seleccione el plano de planta y luego configure las propiedades de la escena",
    dragTip:
      "Seleccione el plano de planta antes de realizar la operación de arrastre",
    editTip: "Editado con éxito",
    addTip: "Al cargar, debe seleccionar todos los planos de planta a la vez",
    editError: "Por favor, especifique el contenido de edición antes de editar",
    delError:
      "Por favor, especifique el contenido a eliminar antes de eliminar",
    delTip: "eliminado con éxito",
    imgAddTip:
      "El número total de planos de planta cargados y agregados ha llegado a 8, y no se pueden agregar más",
    houseTitle: "Cambio de mapa de tipo de casa:",
    delHouseTip:
      "Esta operación eliminará el plano de planta y el contenido de configuración. ¿Desea continuar?",
    sendTip:
      "Importa el contenido de la configuración para volver a modificarlo, puedes subir el archivo xml",
    checkType:
      "El formato del archivo cargado es incorrecto, verifique el contenido del archivo y vuelva a cargarlo",
    importTip: "Importar archivo de configuración",
    importTip1: "Importar el plano de planta correspondiente",
    upLoadBtn: "Subir",
    picContent:
      "El orden de carga de los planos de planta debe ser coherente con el orden de los planos de planta en el archivo de configuración",
    successFile: "Archivo de configuración subido con éxito",
    vineTipCheck:
      "El nombre no puede estar vacío, por favor confirme la entrada",
    picNumMax:
      "Confirme la cantidad de imágenes importadas. La cantidad actual de imágenes importadas es mayor que la cantidad de planos de la casa en el archivo de configuración. Vuelva a seleccionar",
    picNumMin:
      "Confirme la cantidad de imágenes importadas. La cantidad actual de imágenes importadas es menor que la cantidad de planos de la casa en el archivo de configuración. Elija de nuevo",
    maxSizeTip:
      "La cantidad o la cantidad total de adiciones de este tipo supera el límite. Si necesita agregar, primero ordene los dispositivos o escenas agregados",
    devNameTip: "Por favor ingrese un nombre",
    chromeTip: "Se recomienda el navegador Chrome",
    downTip: "Haga clic para saltar al enlace de descarga",
    imgRegTip: "Solo sube archivos en formato jpg y jpeg",
    threeTitle: "Sistema de tres constantes",
    mainControl: "maestro",
    sedControl: "subcontrol",
    controlBtn: "Configuración",
    configEdit: "Detalles de configuración del sistema Sanheng",
    moveTip:
      "Por favor, arrastre el icono al área del plano de planta, arrástrelo de nuevo",
    repeatNameTip:
      "No se pueden cargar planos de planta con el mismo nombre, seleccione de nuevo",
    space: "(Reservado)",
  },
  updateConfig: {
    tip0: "Al configurar la alarma de 24 horas, configure el interruptor en ON",
    tip1: "Al configurar la alarma de 24 horas, el interruptor debe estar encendido",
    tip2: "Al configurar una alarma inmediata, el interruptor debe estar encendido",
    tip3: "Cuando la alarma de demora está desactivada, la demora de entrega debe desactivarse",
    tip4: "Se ha configurado una alarma cruzada, necesita una operación asociada",
    tip5: "Por favor, encienda la alarma de retraso primero",
    tip6: "Al configurar la alarma inmediata, configure el interruptor en encendido",
  },
  audio: {
    title: "Herramienta de empaque de indicaciones de voz",
    lock: "Sonido de desbloqueo",
    call: "Sonido de llamada",
    speak: "Sonido de llamada en curso",
    busy: "Sonido ocupado",
    tip1: "Haga clic para cargar el archivo en formato .wav",
    tip2: "El tamaño del archivo no debe superar 1 MB",
    tip3: "Por favor, cargue un archivo en formato .wav",
    tip4: "Por favor, cargue todos los archivos",
    add: "Generar archivos",
  },
  threeProject: {
    hotWater: "Sistema de agua caliente",
    cho: "Formaldehído",
    config: "Configurar",
    unconfig: "No configurar",
  },
  elevator: {
    title: "Generador de Configuración de Control de Ascensor",
    label: "Subir Tabla de Configuración de Control de Ascensor",
    uploadTip: "Haz clic o arrastra el archivo a esta zona para subirlo",
    upload: "Subir",
    download: "Descargar Plantilla",
    downloadTip:
      "Haz clic para descargar la plantilla de la tabla de configuración de control de ascensor",
    error1:
      "[Piso físico] erróneo. Por favor, revise el archivo de configuración e inténtelo de nuevo.",
    error2:
      "[Piso de visualización] erróneo. Por favor, revise el archivo de configuración e inténtelo de nuevo.",
    error3:
      "[Dirección de la Puerta de Enlace de Control de Ascensor] errónea. Por favor, revise el archivo de configuración e inténtelo de nuevo.",
    error4:
      "[Visualización del Número de Ascensor] errónea. Por favor, revise el archivo de configuración e inténtelo de nuevo.",
    error5:
      "[IP del Dispositivo] errónea. Por favor, revise el archivo de configuración e inténtelo de nuevo.",
    error6:
      "[Puerta de Enlace de Control de Ascensor] límite de cantidad excedido. Por favor, revise el archivo de configuración e inténtelo de nuevo.",
    generate: "Plantilla de Tabla de Configuración de Control de Ascensor",
    fileLabel: "Archivo de Configuración de Control de Ascensor:",
    tip: "Por favor, coloque el archivo de configuración en [Actualización de Recursos] de la herramienta PC para importarlo al dispositivo.",
    downloadfile: "Descargar",
    fileName: "ConfiguracionControlAscensor.xlsx",
    formatError:
      "El formato del archivo subido es incorrecto, por favor revise el contenido del archivo e inténtelo de nuevo",
  },
};
